export const StorageKeys = {
  AccessToken: '@social-control/access_token',
  UserInfo: '@social-control/user_info',
  CodeChallenge: '@social-control/code_challenge',
};
